import React from "react";
import { Container } from "react-bootstrap";
import { useLanguage } from "../context/LanguageContext";

function FooterBottom() {
  const { t } = useLanguage();

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div style={{ backgroundColor: "#6573b6" }} className="py-2">
      <Container className="d-flex justify-content-between align-items-center">
        <span className="text-light font-size-xs">
          <span className="font-size-sm">© </span>
          {new Date().getFullYear()} Centar umjetne inteligencije Lipik. {t("footer.allRightsReserved")}
        </span>
        <span className="d-inline-flex align-items-center"> 
          <a
            className="btn-scroll-top rounded show pl-3 footer-top"
            href="#top"
            onClick={scrollToTop}
            style={{ cursor: "pointer", color: "#ffffff", textDecoration: "none" }}
          >
            ↑ {t("footer.backToTop")}
          </a>
        </span>
      </Container>
    </div>
  );
}

export default FooterBottom;